import { PaginatedApiFetcher } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { handlerApiError } from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import { PaginatedResponse } from '../../../types/request.types';
import { ConnectRepositoryParams } from './myNetworkExplore.repository.types';
import { Explore } from './myNetworkExplore.types';

export const findExplore: PaginatedApiFetcher<Explore> = (params, signal) =>
  restApi.get<PaginatedResponse<Explore>>('/explore', params, { signal });

export const myNetworkExploreRepository = () => {
  const getSellers = (): any => restApi.get(`/brands/users`);

  const connect = async ({
    message,
    destinationId,
    sellers,
    acceptUnverified,
  }: ConnectRepositoryParams) =>
    handlerApiError(
      await restApi.post('invites', { message, destinationId, sellers, acceptUnverified }),
    );

  return {
    getSellers,
    connect,
  };
};
